import {Typography} from 'antd';
import {DocumentFieldsFragment, Maybe} from 'api/generated';
import {Ellipsize} from 'components';
import {getDocumentName} from 'lib/documentUtils';
import React from 'react';
import {Helmet} from 'react-helmet';
import styled from 'styled-components';

type Props = {
  document?: Maybe<DocumentFieldsFragment>;
};

const Title = styled(Typography.Title)`
  position: relative;
  display: flex;
  overflow: hidden;
  margin: 0;
  align-items: center;
`;

export const DocumentTitle: React.FC<Props> = ({document}) => {
  if (!document) return null;

  const name = getDocumentName(document);

  return (
    <Title>
      <Helmet title={name} />
      <Ellipsize>{name}</Ellipsize>
    </Title>
  );
};
